<ng-container [appPreloader]="[endpoints.PROPERTIES_POST, endpoints.PROPERTY_PUT]"
  [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<div mat-dialog-title>
  <div class="dialog-caption">Add Property</div>
  <button mat-dialog-close [mat-dialog-close]="!!property" class="btn icon-close"></button>
</div>

<div mat-dialog-content id="addProperty">
  <mat-stepper class="disabled" linear #stepper>
    <mat-step [stepControl]="$safeNavigationMigration(propertyFormComponent?.form)">
      <ng-template matStepLabel>
        <div class="step-label">
          Add property
        </div>
      </ng-template>

      <ng-template matStepContent>
        <app-property-add-form #propertyFormComponent (saved)="onPropertyAdded($event)"></app-property-add-form>
      </ng-template>
    </mat-step>

    <mat-step [stepControl]="$safeNavigationMigration(valuationFormComponent?.form)">
      <ng-template matStepLabel>
        <div class="step-label">
          Valuation & growth
        </div>
      </ng-template>

      <ng-template matStepContent>
        <app-property-valuation-form #valuationFormComponent
          [property]="property"
          [isSwitcherHidden]="true"
          (saved)="dialogRef.close(true)">
        </app-property-valuation-form>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>

<div mat-dialog-actions class="align-h-space-between">
  <div>
    @if (stepper?.selectedIndex === 1 && propertyFormComponent.isAustralian) {
      <button (click)="openCorelogicDialog()" class="btn primary inverted">
        CoreLogic Disclaimers
      </button>
    }
  </div>
  <div>
    <button class="btn primary" (click)="submitForm()">
      {{ stepper?.selectedIndex === 2 ? 'Save' : 'Next' }}
    </button>
  </div>
</div>
